import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement7Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z"
            fill="url(#paint0_linear_5305_1584)"
        />
        <g filter="url(#filter0_i_5305_1584)">
            <path
                d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
                fill="url(#paint1_linear_5305_1584)"
            />
        </g>
        <path
            d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
            stroke="url(#paint2_linear_5305_1584)"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1584)">
            <path
                d="M78.2065 47.634C78.9402 46.1475 81.0598 46.1475 81.7935 47.634L88.9392 62.1128C89.2305 62.7031 89.7937 63.1123 90.4451 63.2069L106.423 65.5287C108.064 65.7671 108.719 67.783 107.532 68.9401L95.9698 80.2103C95.4985 80.6698 95.2834 81.3318 95.3946 81.9806L98.1241 97.8944C98.4043 99.5282 96.6894 100.774 95.2222 100.003L80.9307 92.4893C80.348 92.183 79.652 92.183 79.0693 92.4893L64.7778 100.003C63.3106 100.774 61.5957 99.5282 61.8759 97.8944L64.6054 81.9806C64.7166 81.3318 64.5015 80.6698 64.0302 80.2103L52.4681 68.9401C51.2811 67.783 51.9361 65.7671 53.5765 65.5287L69.5549 63.2069C70.2063 63.1123 70.7695 62.7031 71.0608 62.1128L78.2065 47.634Z"
                fill="#F5E65F"
            />
            <path
                d="M78.8789 47.9658C79.3088 47.0948 80.5004 47.0404 81.0254 47.8027L81.1211 47.9658L88.2666 62.4443C88.6422 63.2053 89.3463 63.7479 90.1709 63.9199L90.3369 63.9492L106.315 66.2705C107.277 66.4102 107.697 67.5269 107.134 68.2617L107.009 68.4033L95.4463 79.6729C94.8386 80.2652 94.5405 81.1029 94.6318 81.9404L94.6553 82.1074L97.3848 98.0215C97.5488 98.9788 96.6169 99.7233 95.7441 99.415L95.5713 99.3389L81.2793 91.8252C80.5283 91.4305 79.6401 91.4055 78.8721 91.751L78.7207 91.8252L64.4287 99.3389C63.5691 99.7907 62.5738 99.1349 62.5967 98.21L62.6152 98.0215L65.3447 82.1074C65.4882 81.2711 65.2369 80.4188 64.6709 79.7949L64.5537 79.6729L52.9912 68.4033C52.2959 67.7255 52.6123 66.5756 53.499 66.3115L53.6846 66.2705L69.6631 63.9492C70.5028 63.8271 71.236 63.3249 71.6543 62.5938L71.7334 62.4443L78.8789 47.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1584"
                x="21.5"
                y="14.4223"
                width="120"
                height="135.241"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1584"
                />
            </filter>
            <filter
                id="filter1_d_5305_1584"
                x="46.8619"
                y="40.5191"
                width="68.2761"
                height="65.7178"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1584"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1584"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1584"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBE865" />
                <stop offset="1" stopColor="#F1A718" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1584"
                x1="23"
                y1="15"
                x2="151.734"
                y2="126.899"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE33D" />
                <stop offset="1" stopColor="#E1980D" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1584"
                x1="136"
                y1="145"
                x2="23"
                y2="15"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E69614" />
                <stop offset="1" stopColor="#E69614" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement7Icon",
);

export default Achievement7Icon;
